import {FormattableString} from "../FormattableString";
import IMessageTranslator from "./IMessageTranslator.js";
import IStringFormatter from "./IStringFormatter";
import {TranslationsEntry} from "./TranslationsEntry.js";

function lookupClosest(localeId: string, translations: TranslationsEntry[]): TranslationsEntry {
	let name = localeId.toLowerCase();
	while (true) {
		let entry = translations.find(x => x.localeId.toLowerCase() === name);
		if (entry != null) {
			return entry;
		}
		let dash = name.lastIndexOf("-");
		if (dash === -1) {
			return translations[0];
		}
		name = name.substring(0, dash);
	}
}

class EmptyStringFormatter implements IStringFormatter {
	public format(message: FormattableString): string;
	public format(message: string, args?: Record<string, any> | null | undefined): string;
	public format(message: FormattableString | string, args?: Record<string, any> | null | undefined): string {
		return typeof message === "string" ? message : message.text;
	}
}

export default class Translations implements IMessageTranslator {
	private readonly _translations: Record<string, string>;
	private static _defaultFormatter: IStringFormatter = new EmptyStringFormatter();

	constructor(localeId: string, translations: TranslationsEntry[]) {
		this._translations = lookupClosest(localeId, translations).translations;
	}

	get(key: string): string {
		return this._translations[key] || key;
	}

	static getDefaultFormatter(): IStringFormatter {
		return this._defaultFormatter;
	}

	static setDefaultFormatter(formatter: IStringFormatter): void {
		this._defaultFormatter = formatter ?? new EmptyStringFormatter();
	}
}
